import BadwordPage from './BadwordPage'

export default BadwordPage
